$(document).ready(function() {
  initializeCreditCardFields();

  $('#lastInTheForm').click(function(event) {
    var validationOK = true;

    //Validate credit card details client-side
    validationOK = validateCreditCard();

    if (!validationOK) {
      $('#cybersourceSAFormError').removeClass('hide');
      event.preventDefault();
    }

    var form = $('#cybersourceSAForm');

    if (validationOK) {
      validationOK = false;
      //enable fields so they can be posted in request

      if ($('.billing-address').is(':checked')) {
        disableBillingAddress(false);
      }

      event.preventDefault();

      clearCreditCardFormFields();

      $.ajax({
        type: 'POST',
        url: 'ajaxPaymentFormValidation',
        data: form.serialize(),
        async: false,
        success: successRes,
        error: errorRes,
      });
    }

    function successRes(res) {
      if (res.success) {
        //disable fields if necessary
        if ($('.billing-address').is(':checked')) {
          disableBillingAddress(true);
        }
        validationOK = true;
      } else {
        $('#cybersourceSAForm').attr('action', 'paymentFormValidations');
        $('#cybersourceSAForm').submit();
      }
    }

    function errorRes(res) {
      $('#globalMessages ul').append(
        "<div class='alert negative'>Something went wrong while updating Billing Address!! Please try again.</div>"
      );
    }

    if (validationOK) {
      var tokenValue =
        window.tk_gen && typeof window.tk_gen.reCaptchaToken !== 'undefined' ? window.tk_gen.reCaptchaToken : '';

      if (window.tk_gen && window.tk_gen.reCaptchaTokenToggle == true) {
        grecaptcha.ready(function() {
          // Reinitialize the token on submission.
          grecaptcha.execute(window.tk_gen.reCaptchaSiteKey, {action: 'ecommerce'}).then(function(token) {
            tokenValue = token;
            sendReCAPTCHA(tokenValue);
          });
        });
      } else {
        sendReCAPTCHA(tokenValue);
      }
    }

    function sendReCAPTCHA(token) {
      $.ajax({
        type: 'GET',
        url: 'updateSignature',
        async: false,
        data: {
          lastName: $('#bill_to_surname').val(),
          firstName: $('#bill_to_forename').val(),
          line1: $('#bill_to_address_line1').val(),
          line2: $('#bill_to_address_line2').val(),
          city: $('#bill_to_address_city').val(),
          state: $('#bill_to_address_state').val(),
          postCode: $('#bill_to_address_postal_code').val(),
          phoneNumber: $('#bill_to_phone').val(),
          savePaymentInfo: $('#savePaymentInfo').is(':checked'),
          sameAsDeliveryAddr: $('#sameAsDeliveryAddr').is(':checked'),
          reCaptchaToken: token
        },
        success: validationResponse,
        error: validationError,
      });
    }

    function validationResponse(response) {
      if (!response.success && response.message === 'NOT VERIFIED') {
        $('#cybersourceSAFormError').removeClass('hide');
        $('#cybersourceSAFormError').text(response.message);
      } else {
        //hidden credit card fields
        $("input[name='card_type']").val($('#temp_card_type').val());
        $("input[name='card_number']").val($('#temp_card_number').val());
        $("input[name='card_expiry_date']").val(
          $('#temp_card_expiry_month').val() + '-' + $('#temp_card_expiry_year').val()
        );
        $("input[name='card_cvn']").val($('#temp_card_cvn').val());

        $("input[name='amount']").val(response.responseObject.amount);
        $("input[name='access_key']").val(response.responseObject.access_key);
        $("input[name='bill_to_address_city']").val(response.responseObject.bill_to_address_city);
        $("input[name='bill_to_address_country']").val(response.responseObject.bill_to_address_country);
        $("input[name='bill_to_address_line1']").val(response.responseObject.bill_to_address_line1);
        $("input[name='bill_to_address_line2']").val(response.responseObject.bill_to_address_line2);
        $("input[name='bill_to_address_postal_code']").val(response.responseObject.bill_to_address_postal_code);
        $("input[name='bill_to_address_state']").val(response.responseObject.bill_to_address_state);
        $("input[name='bill_to_email']").val(response.responseObject.bill_to_email);
        $("input[name='bill_to_forename']").val(response.responseObject.bill_to_forename);
        $("input[name='bill_to_phone']").val(response.responseObject.bill_to_phone);
        $("input[name='bill_to_surname']").val(response.responseObject.bill_to_surname);
        $("input[name='currency']").val(response.responseObject.currency);
        $("input[name='device_fingerprint_id']").val(response.responseObject.device_fingerprint_id);
        $("input[name='locale']").val(response.responseObject.locale);
        $("input[name='payment_method']").val(response.responseObject.payment_method);
        $("input[name='profile_id']").val(response.responseObject.profile_id);
        $("input[name='reference_number']").val(response.responseObject.reference_number);
        $("input[name='signature']").val(response.responseObject.signature);
        $("input[name='signed_date_time']").val(response.responseObject.signed_date_time);
        $("input[name='signed_field_names']").val(response.responseObject.signed_field_names);
        $("input[name='transaction_type']").val(response.responseObject.transaction_type);
        $("input[name='transaction_uuid']").val(response.responseObject.transaction_uuid);
        $("input[name='unsigned_field_names']").val(response.responseObject.unsigned_field_names);

        //submit form to cybersource
        $('#cybersourceSAForm').submit();
      }
    }

    function validationError(error) {
      $('#globalMessages ul').append(
        "<div class='alert negative'>Something went wrong updating signature!! Please try again.</div>"
      );
    }
  });

  $('#cybersourceSAForm').submit(function() {
    $('#paymentId').attr('name', '');
  });

  var sameAsDeliveryAddrCheckbox = $('#sameAsDeliveryAddr');

  sameAsDeliveryAddrCheckbox.change(function(event) {
    if ($(this).is(':checked')) {
      $.ajax({
        type: 'GET',
        url: 'sameAsDeliveryAddress',
        success: billingSuccess,
        error: billingError,
      });
    } else if ($(this).not(':checked')) {
      $('#bill_to_title').val('');
      $('#select_bill_to_title').text('Select');
      $('#bill_to_forename').val('');
      $('#bill_to_surname').val('');
      $('#bill_to_phone').val('');
      $('#bill_to_address_line1').val('');
      $('#bill_to_address_line2').val('');
      $('#bill_to_address_city').val('');
      $('#bill_to_address_state').val('');
      $('#select_bill_to_address_state').text('Select');
      $('#bill_to_address_postal_code').val('');
      disableBillingAddress(false);
    }
  });

  // Set billing address to be the same as shipping address by default
  if (
    sameAsDeliveryAddrCheckbox.not(':checked') &&
    !$('#bill_to_title').val() &&
    !$('#bill_to_forename').val() &&
    !$('#bill_to_surname').val() &&
    !$('#bill_to_phone').val() &&
    !$('#bill_to_address_line1').val() &&
    !$('#bill_to_address_line2').val() &&
    !$('#bill_to_address_city').val() &&
    !$('#bill_to_address_state').val() &&
    !$('#bill_to_address_postal_code').val()
  ) {
    sameAsDeliveryAddrCheckbox.click();
  }

  function billingSuccess(response) {
    $('#bill_to_title').val(response.responseObject.titleCode);
    var selectedVal = $('select[id=bill_to_title] option:selected').text();
    $('#select_bill_to_title').html(selectedVal);
    $('#bill_to_forename').val(response.responseObject.firstName);
    $('#bill_to_surname').val(response.responseObject.lastName);
    $('#bill_to_phone').val(response.responseObject.phone);
    $('#bill_to_address_line1').val(response.responseObject.line1);
    $('#bill_to_address_line2').val(response.responseObject.line2);
    $('#bill_to_address_city').val(response.responseObject.town);

    var region = response.responseObject.region;
    var setRegion = false;
    var $select = $('#bill_to_address_state');
    var selectedValue = $('select[id=bill_to_address_state] option:selected').val();
    var selectedText = $('select[id=bill_to_address_state] option:selected').text();
    if (region && region.isocodeShort && region.isocodeShort.length > 0) {
      var $option = $select.find('option[value="' + region.isocodeShort + '"]');
      if ($option.length > 0) {
        $('#bill_to_address_state option:selected').each(function() {
          $(this).removeAttr('selected');
        });
        $option.prop('selected', true);
        setRegion = true;
        selectedValue = $("select[id=bill_to_address_state] option[value='" + region.isocodeShort + "']").val();
        selectedText = $("select[id=bill_to_address_state] option[value='" + region.isocodeShort + "']").text();
      }
    }
    if (!setRegion) {
      var $naOption = $select.find('option:nth-child(2)');
      $naOption.attr('selected', 'selected');
      $('#select_bill_to_address_state').text($naOption.text());
    }
    $('#bill_to_address_state').val(selectedValue);
    $('#select_bill_to_address_state').html(selectedText);
    $('#bill_to_address_postal_code').val(response.responseObject.postalCode);
    disableBillingAddress(true);
  }

  function billingError(error) {
    $('#globalMessages ul').append("<div class='alert negative'>Something went wrong!! Please try again.</div>");
    disableBillingAddress(false);
  }

  $('#checkout-step3-wallet-choosePaymentMethodBtn').click(function() {
    $('.selected form').submit();
  });

  function disableBillingAddress(toggle) {
    if (toggle) {
      $('#bill_to_title').attr('disabled', 'disabled');
      $('#bill_to_forename').attr('disabled', 'disabled');
      $('#bill_to_surname').attr('disabled', 'disabled');

      if ($('#bill_to_phone').val() != '') {
        $('#bill_to_phone').attr('disabled', 'disabled');
      }
      $('#bill_to_address_line1').attr('disabled', 'disabled');
      $('#bill_to_address_line2').attr('disabled', 'disabled');
      $('#bill_to_address_city').attr('disabled', 'disabled');
      $('#bill_to_address_state').attr('disabled', 'disabled');
      $('#select_bill_to_address_state')
        .addClass('form__item--disabled')
        .removeClass('arrow-down-isolated-icon-after');
      $('#bill_to_address_postal_code').attr('disabled', 'disabled');
    } else {
      $('#bill_to_title').removeAttr('disabled');
      $('#bill_to_forename').removeAttr('disabled');
      $('#bill_to_surname').removeAttr('disabled');
      $('#bill_to_phone').removeAttr('disabled');
      $('#bill_to_address_line1').removeAttr('disabled');
      $('#bill_to_address_line2').removeAttr('disabled');
      $('#bill_to_address_city').removeAttr('disabled');
      $('#bill_to_address_state').removeAttr('disabled');
      $('#select_bill_to_address_state')
        .removeClass('form__item--disabled')
        .addClass('arrow-down-isolated-icon-after');
      $('#bill_to_address_postal_code').removeAttr('disabled');
    }
  }

  function showFormError(groupName) {
    var groupParent = $('#' + groupName).closest('li');
    var trimmedContent = $.trim(groupParent.html());

    if (trimmedContent.indexOf('form__item--error') === -1) {
      //form validation message not rendered yet
      var newContent = '<div class="form__item--error alert-icon-after">' + trimmedContent + '</div>';
      var postalCodeErrorMessage = $('.form__item--error').find("input[id='bill_to_address_postal_code']");
      postalCodeErrorMessage.closest('div.form__item--error').removeClass('alert-icon-after');
      groupParent.empty().append(newContent);
      groupParent.find('em.form__message').show();
    }
  }

  function hideFormError(groupName, fieldName, fieldValue) {
    var groupParent = $('#' + groupName).closest('li');

    var trimmedContent = $.trim(groupParent.html());

    if (trimmedContent.indexOf('form__item--error') !== -1) {
      var newContent = $(trimmedContent).html();

      groupParent.empty().append(newContent);
      $('#' + fieldName).val(fieldValue);
      groupParent.find('em.form__message').hide();
    }
  }

  function validateCreditCard() {
    var country = !window.ACC ? 'en_US' : window.ACC.languageISO;
    var hidPostcodeRegex = $('input[name=hidPostcodeRegex]').val()
      ? $('input[name=hidPostcodeRegex]').val()
      : '^[0-9]{5,5}$';
    var validationData = {
      bill_to_address_postal_code: {
        regex: function() {
          return hidPostcodeRegex;
        },
      },
      card_cvn: {
        regex: function() {
          return /^[0-9]{3,4}$/;
        },
      },
    };

    if (country === 'en_GB') {
      validationData['card_cvn'] = {
        regex: function() {
          return /^[0-9]{3,4}$/;
        },
      };
    }

    var isContactFieldsOk = true;
    var errorFields = [],
      inputFields = $('#cybersourceSAForm').find(
        "input[required='true'],input[required='required'],select[required='true'],select[required='required']"
      );

    inputFields.each(function() {
      if ($(this).is('SELECT') && $.trim($(this).val()).length == 0) {
        var elementId = $(this).attr('id');
        var elementValue = $('#' + elementId + ' option[selected]').val();

        if ($.trim(elementValue).length == 0) {
          errorFields.push(this);
        } else {
          hideFormError($(this).attr('id'), $(this).attr('id'), elementValue);
        }
        return;
      } else if ($.trim($(this).val()).length == 0) {
        errorFields.push(this);
      } else {
        hideFormError($(this).attr('id'), $(this).attr('id'), $(this).val());
      }
    });

    for (var key in validationData) {
      var $field = $('#' + key);
      var value = $field.val();
      $field.attr('value', value);

      var regex = validationData[key].regex();

      if (!value.match(regex)) {
        errorFields.push($('#' + key));
      } else {
        hideFormError(key, key, value);
      }
    }

    if (errorFields.length > 0) {
      isContactFieldsOk = false;
      $(errorFields).each(function() {
        showFormError($(this).attr('id'));
      });
      $('html, body').animate(
        {
          scrollTop: $('#page').offset().top,
        },
        500
      );
    }

    var cardTypeOk = true;
    var cardNumberOk = true;
    var cardNameOk = true;
    var cardCvnOk = true;
    var cardMonthOk = true;
    var cardYearOk = true;

    var cardType = $.trim($('#cardType option:selected').val());
    if ($.trim($('#cardType option:selected').text()) == 'Please choose') {
      cardTypeOk = false;
    }

    if (!cardTypeOk) {
      showFormError('cardType');
    } else {
      hideFormError('cardType', 'cardType', cardType);
    }
    var cardNumber = cardUtils.getNumber();

    if (cardNumber == '') {
      cardNumberOk = false;
    } else if (cardNumber.length > 16 || cardNumber.length < 13) {
      cardNumberOk = false;
    } else if (!$.isNumeric(cardNumber)) {
      cardNumberOk = false;
    }

    if (!cardNumberOk) {
      showFormError('cardNumber');
    } else {
      hideFormError('cardNumber', 'cardNumber', cardNumber);
    }

    var name = $.trim($('#nameOnCard').val());

    if (name == '') {
      $('#cardNameError').show();
      cardNameOk = false;
    }

    if (!cardNameOk) {
      showFormError('nameOnCard');
    } else {
      hideFormError('nameOnCard', 'nameOnCard', name);
    }

    var cvn = $.trim($('#card_cvn').val());

    if (cvn == '') {
      cardCvnOk = false;
    } else if (cvn.length > 4 || cvn.length < 3) {
      cardCvnOk = false;
    } else if (!$.isNumeric(cvn)) {
      cardCvnOk = false;
    }

    if (!cardCvnOk) {
      showFormError('card_cvn');
    } else {
      hideFormError('card_cvn', 'card_cvn', cvn);
    }

    var expiryMonth = $.trim($('#ExpiryMonth option:selected').val());
    if ($.trim($('#ExpiryMonth option:selected').text()) == 'MM') {
      cardMonthOk = false;
    }

    if (!cardMonthOk) {
      showFormError('ExpiryMonth');
    } else {
      hideFormError('ExpiryMonth', 'ExpiryMonth', expiryMonth);
    }

    var expiryYear = $.trim($('#ExpiryYear option:selected').val());
    if ($.trim($('#ExpiryYear option:selected').text()) == 'YYYY') {
      cardYearOk = false;
    }

    if (!cardYearOk) {
      showFormError('ExpiryYear');
    } else {
      hideFormError('ExpiryYear', 'ExpiryYear', expiryYear);
    }

    if (
      !cardTypeOk ||
      !cardNumberOk ||
      !cardNameOk ||
      !cardCvnOk ||
      !cardMonthOk ||
      !cardYearOk ||
      !isContactFieldsOk
    ) {
      // Have to re-attach the event handlers after they are lost with trimmedContent = $.trim(groupParent.html());
      initializeCreditCardFields();
      return false;
    } else {
      return true;
    }
  }

  function clearCreditCardFormFields() {
    //save em
    $('#temp_card_type').val($.trim($('#cardType option:selected').val()));
    $('#temp_card_number').val(cardUtils.getNumber());
    $('#temp_card_name').val($.trim($('#nameOnCard').val()));
    $('#temp_card_cvn').val($.trim($('#card_cvn').val()));
    $('#temp_card_expiry_month').val($.trim($('#ExpiryMonth option:selected').text()));
    $('#temp_card_expiry_year').val($.trim($('#ExpiryYear option:selected').text()));

    //clear em
    $('#cardType').val('');
    $('#cardNumber').val('');
    $('#nameOnCard').val('');
    $('#card_cvn').val('');
    $('#ExpiryMonth').val('');
    $('#ExpiryYear').val('');
  }

  var cardUtils = {
    numberFormats: {
      '001': {
        // visa, visa electron
        format: 'XXXX XXXX XXXX XXXX',
        digits: 16,
      },
      '002': {
        // mastercard
        format: 'XXXX XXXX XXXX XXXX',
        digits: 16,
      },
      '003': {
        // amex
        format: 'XXXX XXXXXX XXXXX',
        digits: 15,
      },
      '042': {
        // maestro
        format: 'XXXX XXXX XXXX XXXX',
        digits: 16,
      },
      '024': {
        // maestro
        format: 'XXXX XXXX XXXX XXXX',
        digits: 16,
      },
    },
    getType: function() {
      return $.trim($('#cardType option:selected').val());
    },
    getNumber: function() {
      return $('#cardNumber')
        .val()
        .replace(/\D/g, '');
    },
    getRawValue: function() {
      return $('#cardNumber').val();
    },
    getFormattedNumber: function() {
      var cardNumber = this.getNumber();
      var cardType = this.getType();

      if (cardType && this.numberFormats[cardType]) {
        return this.applyFormat(cardNumber, this.numberFormats[cardType].format);
      } else {
        return cardNumber;
      }
    },
    /**
     * Apply a format mask to the given card number
     *
     * @param string
     * @param mask
     * @returns {string}
     */
    applyFormat: function(cardNumber, mask) {
      var formattedString = '';
      var numberPos = 0;
      for (var j = 0; j < mask.length; j++) {
        var currentMaskChar = mask[j];
        if (currentMaskChar == 'X') {
          var digit = cardNumber.charAt(numberPos);
          if (!digit) {
            break;
          }
          formattedString += cardNumber.charAt(numberPos);
          numberPos++;
        } else {
          formattedString += currentMaskChar;
        }
      }
      return formattedString;
    },
  };

  function initializeCreditCardFields() {
    // Initialize credit card formatting after credit card type is selected
    $('#cardType').change(function() {
      var cardType = cardUtils.getType();
      if (cardType && cardUtils.numberFormats[cardType]) {
        $('#cardNumber__help').text(cardUtils.numberFormats[cardType].format);
      }
      if (cardUtils.getNumber()) {
        $('#cardNumber').val(cardUtils.getFormattedNumber());
      }
    });

    $('#cardNumber').blur(function() {
      $(this).val(cardUtils.getFormattedNumber());
    });
  }
});
